import { Component, computed, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { CommonModule, NgOptimizedImage, ViewportScroller } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { DeviceService } from '../services/device.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { slideInRightAnimation, slideInAnimation } from '../shared/animations/animations';
import { DashboardIntroComponent } from './components/dashboard-intro/dashboard-intro.component';
import { DashboardOverviewComponent } from '../dashboard/dashboard-components/dashboard-overview/dashboard-overview.component';
import { UserCompanyService } from '../services/userCompany.service';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { OverviewComponent } from '../dashboard/dashboard-components/company-identity/components/overview/overview.component';
import { CompanyBalanceComponent } from '../dashboard/dashboard-components/company-identity/components/company-balance/company-balance.component';
import { ReportComponent } from '../report/report.component';
import { PromoFeaturesComponent } from '../report/components/promo-features/promo-features.component';
import { PricePlansComponent } from '../shared/price-plans/price-plans.component';
import { SectionBenchmarkComponent } from './components/section-benchmark/section-benchmark.component';
import { SectionOeComponent } from './components/section-oe/section-oe.component';
import { LandingService } from '../services/landing.service';
import { SectionBollettaComponent } from './components/section-bolletta/section-bolletta.component';
import { CompanyDataErrorComponent } from '../dashboard/dashboard-components/company-data-error/company-data-error.component';
import { SectionProductsRelatedComponent } from './components/section-products-related/section-products-related.component';
import { ProductsRelatedComponent } from '../products-related/products-related.component';
import { SectionTrialsComponent } from './components/section-trials/section-trials.component';
@Component({
  selector: 'app-dashboard-dynamic',
  standalone: true,
  imports: [CommonModule,
    TranslateModule,
    MatButtonModule,
    DashboardIntroComponent,
    SectionBenchmarkComponent,
    // SectionOeComponent,
    SectionBollettaComponent,
    CompanyDataErrorComponent,
    SectionProductsRelatedComponent,
    ProductsRelatedComponent,
    SectionTrialsComponent
  ],
  templateUrl: './dashboard-dynamic.component.html',
  styleUrls: ['./dashboard-dynamic.component.scss'],
  animations: [
    slideInAnimation,
    slideInRightAnimation,
    trigger('fadeInRight', [
      state('void', style({
        opacity: 0,
        transform: 'translateX(-100px)'
      })),
      transition('void => *', [
        animate('1s {{ delay }} ease-out', style({
          opacity: 1,
          transform: 'translateX(0%)'
        }))
      ], { params: { delay: '0s' } })
    ]),
    trigger('fadeInLeft', [
      state('void', style({
        opacity: 0,
        transform: 'translateX(100px)'
      })),
      transition('void => *', [
        animate('1s {{ delay }} ease-out', style({
          opacity: 1,
          transform: 'translateX(0%)'
        }))
      ], { params: { delay: '0s' } })
    ])
  ]
})
export class DashboardDynamicComponent implements OnInit{
  activeSection = signal<any | null>(null);
  company: any;
  companyEureso: any;
  companyAteco: any;
  companyPiva: any;

  isMobile = signal<boolean>(this.deviceService.is_mobile());

  hasBenchmark$ = signal<boolean>(false);
  loading$ = signal<boolean>(true);
  missingFinancials$ = signal<boolean>(false);
  companyAnalizingErrors$ = signal<string[]>([]);

  productSkusToPromote$ = signal<string[]>(['marker', 'obiettivo-europa','report-digital']);


  private unsubscribe$ = new Subject<void>();

  constructor(private deviceService: DeviceService,
    private userCompanyService: UserCompanyService,
    private viewportScroller: ViewportScroller,
    private landingService: LandingService
  ) { }
  ngOnInit(): void {
    // if (!this.isMobile()) {
      this.initBenchmarkPromo();
    // }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  scrollToElement(elementId: string): void { 
		this.viewportScroller.scrollToAnchor(elementId);
	}

  onClickedSection(event: any) {

    if (!this.isMobile()) {
      this.scrollToElement(event);
    } else {
      console.log(event);
      this.activeSection.set(event);
      
      // switch (event) {
      //   case 'benchmark':
      //     this.initBenchmarkPromo();
      //     break;
      //   case 'obiettivoeuropa':
      //     this.initObiettivoEuropa();
      //     break;
      //   default:
      //     break;
      // }
    }
  }

  initBenchmarkPromo() { 
    this.landingService.getDashboard().then((res) => {
      
      console.log('res', res);
      if (res && Object.keys(res).length > 0) {
        this.company = res?.company;
       
        if (this.company) {
          if (!this.company.eureso_overview || !this.company.eureso_overview.localFinancialStatements) {
            this.missingFinancials$.set(true);
            this.companyAnalizingErrors$.set(['Dati finanziari mancanti']);
            return;
          }
          if(this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests) > 0) {
            this.hasBenchmark$.set(true);
          }
          this.companyEureso = this.company.eureso_overview;
          this.companyAteco = this.company.eureso_overview.companySummary?.mainActivity?.code;
          this.companyPiva = this.company.eureso_overview.alternateSummary?.vatRegistrationNumber
        } else {
          // todo gestire errore
          this.missingFinancials$.set(true);
          this.companyAnalizingErrors$.set(['Dati finanziari mancanti']);
          return;
        }
      }
      
    }).catch((err: any) => {
      console.log('err', err);
    }).finally(() => {
      this.loading$.set(false);
    })


    // this.userCompanyService.userCompany$.pipe(
    //   catchError((err: any) => {
    //     console.log('err', err);
    //     return err;
    //   }),
    //   takeUntil(this.unsubscribe$)
    // ).subscribe((res: any) => {
    //   if (res && res.company) {
    //     this.company = res.company;
    //     this.companyEureso = this.company.eureso_overview;
    //     this.companyAteco = this.company.eureso_overview.companySummary?.mainActivity?.code;
    //     this.unsubscribe$.next();
    //     this.unsubscribe$.complete();
    //   }
    //     // this.manageCompanyData(this.company);
        
    //   console.log('company', this.company)
    //   }
    //   );

  }

  closeSidenav() {
    this.activeSection.set(false);
  }
  

}
